import { useState } from "react";
import { Link } from "react-router-dom";
import MainHeader from "../../components/layout/MainHeader";
import PageHeader from "../../components/layout/PageHeader";
import Footer from "../../components/layout/Footer";
import { useTranslation } from "react-i18next";
import useAnimateCss, { useAnimateCssStagger } from "../../hooks/useAnimateCss";

// import headerImg from "../../assets/images/background/13a.jpg";
import headerImg from "../../assets/images/misc/man-in-location.webp";
import commitBg from "../../assets/images/misc/men-in-location.jpg";

import rebarImg from "../../assets/images/misc/why-choose-us.webp";
import billetImg from "../../assets/images/misc/billet-3.webp";

import iconStandards from "../../assets/icons/qctrl-badge.webp";
import iconResidential from "../../assets/icons/qctrl-crane.webp";
import iconStrength from "../../assets/icons/qctrl-beam.webp";
import iconDiameters from "../../assets/icons/qctrl-caliper.webp";

import cert1j from "../../assets/images/quality/certifications/1.jpg";
import cert2j from "../../assets/images/quality/certifications/2.jpg";
import cert3j from "../../assets/images/quality/certifications/3.jpg";
import cert4j from "../../assets/images/quality/certifications/4.jpg";
import cert1p from "../../assets/images/quality/certifications/1.png";
import cert2p from "../../assets/images/quality/certifications/2.png";
import cert3p from "../../assets/images/quality/certifications/3.png";
import cert4p from "../../assets/images/quality/certifications/4.png";
import cert5 from "../../assets/images/quality/certifications/5.png";
import cert6 from "../../assets/images/quality/certifications/6.png";
import cert7 from "../../assets/images/quality/certifications/7.png";
import cert8 from "../../assets/images/quality/certifications/8.png";
import cert9 from "../../assets/images/quality/certifications/9.png";



const consultCerts = [
  cert1j,
  cert1p,
  cert2j,
  cert2p,
  cert3j,
  cert3p,
  cert4j,
  cert4p,
  cert5,
  cert6,
  cert7,
  cert8,
  cert9,
];
const accreCerts = [cert5, cert6, cert7, cert8, cert9];
const consultDup = [...consultCerts, ...consultCerts];
const accreDup = [...accreCerts, ...accreCerts];

const rebarFeatures = [
  { icon: iconStandards, labelKey: "qctrl-rebar-feat-1" },
  { icon: iconResidential, labelKey: "qctrl-rebar-feat-2" },
  { icon: iconStrength, labelKey: "qctrl-rebar-feat-3" },
  { icon: iconDiameters, labelKey: "qctrl-rebar-feat-4" },
];

const billetFeatures = [
  { icon: iconStandards, labelKey: "qctrl-billet-feat-1" },
  { icon: iconResidential, labelKey: "qctrl-billet-feat-2" },
];

/* ── Steel specs popup tables ── */
function SteelSpecsModal({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="qspec-overlay" onClick={onClose}>
      <div className="qspec-content" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="qspec-close" onClick={onClose}>×</button>

        <table className="qspec-table">
          <thead>
            <tr>
              <th>#</th>
              <th>{t("qctrl-modal-item")}</th>
              <th>{t("qctrl-modal-accept")}</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>1</td><td>{t("qctrl-modal-standard")}</td><td>Egyptian Standard 262-2/2021</td></tr>
            <tr><td>2</td><td>{t("qctrl-modal-grade")}</td><td>B500 CWR / B500 DWR</td></tr>
            <tr><td>3</td><td>{t("qctrl-modal-length")}</td><td>12 M</td></tr>
            <tr><td>4</td><td>{t("qctrl-modal-diameter")}</td><td>8, 10, 12, 16, 18, 22, 25, 32 mm</td></tr>
            <tr><td>5</td><td>{t("qctrl-modal-capacity")}</td><td>450,000 ton/year</td></tr>
            <tr><td>6</td><td>{t("qctrl-modal-packing")}</td><td>About 2 ton</td></tr>
          </tbody>
        </table>

        <br />

        <table className="qspec-table">
          <thead>
            <tr>
              <th>{t("qctrl-modal-standard")}</th>
              <th>{t("qctrl-modal-grade")}</th>
              <th>{t("qctrl-modal-yield")}</th>
              <th>{t("qctrl-modal-tensile")}</th>
              <th>{t("qctrl-modal-elongation")}</th>
              <th>{t("qctrl-modal-ratio")}</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>262-2/2021</td><td>B400 DWR</td><td>400</td><td>432</td><td>14</td><td>1.15</td></tr>
            <tr><td>262-2/2021</td><td>B500 DWR</td><td>500</td><td>575</td><td>14</td><td>1.25</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ── Billet specs popup tables ── */
function BilletSpecsModal({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="qspec-overlay" onClick={onClose}>
      <div className="qspec-content" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="qspec-close" onClick={onClose}>×</button>

        <table className="qspec-table">
          <thead>
            <tr>
              <th scope="col">{t("qctrl-modal-property")}</th>
              <th className="qspec-red" scope="col">Carbon C%</th>
              <th className="qspec-red" scope="col">Silicon Si%</th>
              <th className="qspec-red" scope="col">Manganese Mn%</th>
              <th className="qspec-red" scope="col">Phosphorus P%</th>
              <th className="qspec-red" scope="col">Sulfur S%</th>
            </tr>
            <tr>
              <th scope="row">{t("qctrl-modal-chemistry")}</th>
              <td>0.22–0.32</td>
              <td>0.15–0.30</td>
              <td>0.50–0.70</td>
              <td>0.055</td>
              <td>0.055</td>
            </tr>
          </thead>
        </table>

        <br />

        <table className="qspec-table">
          <thead>
            <tr>
              <th>#</th>
              <th>{t("qctrl-modal-item")}</th>
              <th>{t("qctrl-modal-accept")}</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>1</td><td>{t("qctrl-modal-standard")}</td><td>Egyptian Standard 262-2/2021</td></tr>
            <tr><td>2</td><td>{t("qctrl-modal-length")}</td><td>6 M, 8 M, 12 M</td></tr>
            <tr><td>3</td><td>{t("qctrl-modal-size")}</td><td>130×130 mm / 160×160 mm</td></tr>
            <tr><td>4</td><td>{t("qctrl-modal-capacity")}</td><td>300,000 ton/year</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

function QualityControl() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<"rebar" | "billet">("rebar");
  const [showSteelModal, setShowSteelModal] = useState(false);
  const [showBilletModal, setShowBilletModal] = useState(false);

  /* Tab section */
  const tabBtnsRef   = useAnimateCss("animate__fadeInDown", 0,   0.15);

  /* Certifications marquee */
  const certLabelRef = useAnimateCss("animate__fadeInDown", 0,   0.15);
  const certHeadRef  = useAnimateCss("animate__fadeInUp",   120, 0.15);
  const certIntroRef = useAnimateCss("animate__fadeInUp",   220, 0.15);
  const certTrackRef = useAnimateCss("animate__fadeIn",     300, 0.1,  900);

  /* Commitment section */
  const commitHeadRef = useAnimateCss("animate__fadeInLeft",  0,   0.15);
  const commitTextRef = useAnimateCss("animate__fadeInLeft",  120, 0.15);
  const commitLinkRef = useAnimateCss("animate__fadeInLeft",  220, 0.15);
  const statsRef      = useAnimateCssStagger("animate__fadeInRight", 110, 0.1);

  /* Product Accreditation marquee */
  const acreLabelRef  = useAnimateCss("animate__fadeInDown", 0,   0.15);
  const acreHeadRef   = useAnimateCss("animate__fadeInUp",   120, 0.15);
  const acreTrackRef  = useAnimateCss("animate__fadeIn",     300, 0.1,  900);

  return (
    <>
      <MainHeader />
      <PageHeader image={headerImg} title={t("Quality")} />

      {/* ── Tab section ── */}
      <section className="qctrl-section">
        <div className="container">
          {/* Tab buttons */}
          <div className="qctrl-tabs" ref={tabBtnsRef as any}>
            <button
              type="button"
              className={`qctrl-tab-btn${activeTab === "rebar" ? " active" : ""}`}
              onClick={() => setActiveTab("rebar")}
            >
              {t("Steel Rebar")}
            </button>
            <button
              type="button"
              className={`qctrl-tab-btn${activeTab === "billet" ? " active" : ""}`}
              onClick={() => setActiveTab("billet")}
            >
              {t("Billet")}
            </button>
          </div>

          {/* ── Rebar tab ── */}
          {activeTab === "rebar" && (
            <div className="row g-5 align-items-start">
              {/* LEFT */}
              <div className="col-lg-6">
                <p className="qctrl-desc">{t("qctrl-rebar-desc")}</p>

                <div className="qctrl-feature-grid">
                  {rebarFeatures.map((f, i) => (
                    <div key={i} className="qctrl-feature-item">
                      <div className="qctrl-feature-icon">
                        <img src={f.icon} alt="" />
                      </div>
                      <span className="qctrl-feature-label">{t(f.labelKey)}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* RIGHT */}
              <div className="col-lg-6">
                <img
                  src={rebarImg}
                  alt="Steel Rebar"
                  className="qctrl-product-img"
                />
                <button
                  type="button"
                  className="qctrl-specs-btn"
                  onClick={() => setShowSteelModal(true)}
                >
                  {t("qctrl-view-specs")}
                </button>
              </div>
            </div>
          )}

          {/* ── Billet tab ── */}
          {activeTab === "billet" && (
            <div className="row g-5 align-items-start">
              {/* LEFT */}
              <div className="col-lg-6">
                <p className="qctrl-desc">{t("qctrl-billet-desc")}</p>

                <div className="qctrl-feature-grid">
                  {billetFeatures.map((f, i) => (
                    <div key={i} className="qctrl-feature-item">
                      <div className="qctrl-feature-icon">
                        <img src={f.icon} alt="" />
                      </div>
                      <span className="qctrl-feature-label">{t(f.labelKey)}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* RIGHT */}
              <div className="col-lg-6">
                <img
                  src={billetImg}
                  alt="Steel Billet"
                  className="qctrl-product-img"
                />
                <button
                  type="button"
                  className="qctrl-specs-btn"
                  onClick={() => setShowBilletModal(true)}
                >
                  {t("qctrl-view-specs")}
                </button>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* ── Consulting Eng. Approvals ── */}
      <section className="projects-cert-section">
        <div className="container">
          <span className="page-section-label" ref={certLabelRef as any}>{t("Certifications")}</span>
          <h2 className="inner-page-heading" ref={certHeadRef as any}>
            {t("Consulting engineering approvals")}
          </h2>
          <p className="cert-intro" ref={certIntroRef as any}>{t("accreditation-info")}</p>
        </div>
        {/* <div className="projects-cert-marquee-wrapper" ref={certTrackRef as any}>
          <div className="projects-cert-fade projects-cert-fade--left" />
          <div className="projects-cert-fade projects-cert-fade--right" />
          <div className="projects-cert-track projects-cert-track--fast">
            {consultDup.map((src, i) => (
              <a
                key={i}
                href={src}
                target="_blank"
                rel="noreferrer"
                className="projects-cert-item"
              >
                <img
                  src={src}
                  alt={`Approval ${(i % consultCerts.length) + 1}`}
                />
              </a>
            ))}
          </div>
        </div> */}
      </section>

      {/* ── Our Commitment to Quality ── */}
      <section className="qctrl-commitment">
        <div className="container">
          <div
            className="qctrl-commit-wrapper"
            style={{ backgroundImage: `url("${commitBg}")` }}
          >
            <div className="qctrl-commitment-overlay" />
            <div className="qctrl-commit-content">
              <div className="row g-5 align-items-center">
                {/* LEFT */}
                <div className="col-lg-6">
                  <h2 className="qctrl-commit-heading" ref={commitHeadRef as any}>{t("qctrl-commit-heading")}</h2>
                  <p className="qctrl-commit-text" ref={commitTextRef as any}>{t("qctrl-commit-text")}</p>
                  <Link to="/who-we-are" className="qctrl-commit-link" ref={commitLinkRef as any}>
                    {t("qctrl-commit-link")} &nbsp;
                    <i className="bi bi-arrow-right" />
                  </Link>
                </div>

                {/* RIGHT — stat boxes */}
                <div className="col-lg-6">
                  <div className="qctrl-stats-grid" ref={statsRef as any}>
                    <div className="qctrl-stat-box box-1">
                      <p className="qctrl-stat-number b-">500+</p>
                      <p className="qctrl-stat-label">{t("qctrl-stat-1-label")}</p>
                    </div>

                    <div className="qctrl-stat-box box-2">
                      <div className="qctrl-stat-icon">
                        <i className="bi bi-patch-check" />
                      </div>
                      <div className="qctrl-stat-text-row">
                        <p className="qctrl-stat-number">18+</p>
                        <p className="qctrl-stat-label">{t("qctrl-stat-2-label")}</p>
                      </div>
                    </div>

                    <div className="qctrl-stat-box box-3">
                      <p className="qctrl-stat-number">300+</p>
                      <p className="qctrl-stat-label">{t("qctrl-stat-3-label")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Product Accreditation ── */}
      <section className="projects-cert-section">
        {/* <div className="container">
          <span className="page-section-label" ref={acreLabelRef as any}>
            {t("Accreditation & Approvals")}
          </span>
          <h2 className="inner-page-heading" ref={acreHeadRef as any}>{t("Product accreditation")}</h2>
        </div> */}
        {/* <div className="projects-cert-marquee-wrapper" ref={acreTrackRef as any}>
          <div className="projects-cert-fade projects-cert-fade--left" />
          <div className="projects-cert-fade projects-cert-fade--right" />
          <div className="projects-cert-track projects-cert-track--slow">
            {accreDup.map((src, i) => (
              <a
                key={i}
                href={src}
                target="_blank"
                rel="noreferrer"
                className="projects-cert-item"
              >
                <img
                  src={src}
                  alt={`Certificate ${(i % accreCerts.length) + 1}`}
                />
              </a>
            ))}
          </div>
        </div> */}
      </section>

      <Footer />

      {showSteelModal && (
        <SteelSpecsModal onClose={() => setShowSteelModal(false)} />
      )}
      {showBilletModal && (
        <BilletSpecsModal onClose={() => setShowBilletModal(false)} />
      )}
    </>
  );
}

export default QualityControl;
